import { Box, Divider, Stack, Typography } from "@mui/material"
import { LoadingButton, isDefined } from "@pharmupp/p3-front-commons"
import { LocationType } from "../../../../Events/model"
import type { ApiNewsEvent } from "../../../../News/model"
import type { FormattedNews, NewsProps } from "../News"
import {
  EventCancelled,
  EventDate,
  EventIrl,
  EventRemote,
  RemainingSubscription,
} from "./Details"
import { Subscription } from "./Subscription"

type EventSectionProps = Omit<NewsProps, "category" | "news" | "newsLoading"> & {
  news: FormattedNews<ApiNewsEvent>
}

export const EventSection = ({
  news: {
    remainingSubscriptions,
    startDate,
    endDate,
    isRegistered,
    canSubscribe,
    canUnsubscribe,
    registrationDeadline,
    cancelled,
    cancellationReason,
    ...news
  },
  subscribe,
  subscribeLoading,
  unsubscribe,
  unsubscribeLoading,
}: EventSectionProps) => {
  return (
    <Box
      p={5}
      my={5}
      bgcolor="grey.extraLight"
      display="flex"
      flexDirection="column"
      gap={3}
    >
      <Typography variant="h5" color="common.darkBlue">
        Détails de l’évènement
        {!!cancelled && (
          <>
            {" "}
            :{" "}
            <Typography color="common.red" component="span" variant="h5">
              Annulé
            </Typography>
          </>
        )}
      </Typography>

      <Stack direction="row" justifyContent="space-between" mt={3}>
        <Stack spacing={3} divider={<Divider />}>
          <Stack direction="row" spacing={3}>
            <EventDate
              cancelled={cancelled}
              startDate={startDate}
              endDate={endDate}
            />

            {isDefined(remainingSubscriptions) && !cancelled && (
              <RemainingSubscription count={remainingSubscriptions} />
            )}
          </Stack>

          {cancelled ? (
            !!cancellationReason && (
              <EventCancelled cancellationReason={cancellationReason} />
            )
          ) : news.locationType === LocationType.REMOTE ? (
            <EventRemote meetUrl={news.meetUrl} isRegistered={isRegistered} />
          ) : (
            <EventIrl {...news.address} />
          )}
        </Stack>
        {!cancelled && (
          <Subscription
            isRegistered={isRegistered}
            canSubscribe={canSubscribe}
            registrationDeadline={registrationDeadline}
            remainingSubscriptions={remainingSubscriptions ?? 1}
            subscribe={subscribe}
            subscribeLoading={subscribeLoading}
          />
        )}
      </Stack>

      {!!unsubscribe && canUnsubscribe && (
        <>
          <Divider />

          <Box display="flex" justifyContent="center">
            <LoadingButton
              variant="outlined"
              onClick={() => unsubscribe()}
              loading={unsubscribeLoading}
            >
              Se désinscrire
            </LoadingButton>
          </Box>
        </>
      )}
    </Box>
  )
}
